import React, { Ref, useEffect, useState, ChangeEvent, createRef } from 'react';

export interface InputProps {
	ref?: Ref<HTMLInputElement>;
	id: string;
	value?: string;
	name?: string;
	type?: string;
	placeholder?: string;
	isInvalid?: boolean;
	onBlur(): void;
	onChange(value: string): void;
}

export function Input({ ref, id, value, name, type = 'text', placeholder, isInvalid, onBlur, onChange }: InputProps) {
	const elementRef = ref ? ref : createRef<HTMLInputElement>();
	const [inputValue, setInputValue] = useState(value || '');

	useEffect(() => {
		if (value == inputValue) {
			return;
		}
		const inputTimer = setTimeout(() => {
			onChange(inputValue);
		}, 500);

		return () => clearTimeout(inputTimer);
	}, [inputValue]);

	const handleChangeInputValue = (item: ChangeEvent<HTMLInputElement>) => {
		const { target } = item;

		setInputValue(target.value);
	};

	return (
		<input
			ref={elementRef}
			className={`block px-2 w-full h-8 border rounded border-gray-300 text-[14px] leading-7 text-black bg-white shadow ${
				isInvalid && 'focus:ring-2 focus:ring-offset-1 focus:ring-red-300 !border-red-500'
			}`}
			id={id}
			name={name}
			type={type}
			placeholder={placeholder}
			value={inputValue}
			onBlur={onBlur}
			onChange={handleChangeInputValue}
		/>
	);
}
